import React from 'react';
import DialogActionsBase from '@material-ui/core/DialogActions';

const DialogActions = (props) => <DialogActionsBase {...props} />;

export default DialogActions;
